import { Button } from '@/components/ui-kit/button';
import { RotateCcw } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface TrashRowActionsProps {
  isLoading: boolean;
  handleRestore: () => void;
}

const TrashRowActions = ({ isLoading, handleRestore }: TrashRowActionsProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-end items-center gap-1.5">
      <Button
        type="button"
        variant="ghost"
        size="icon-sm"
        className="text-selise-blue-500 hover:text-selise-blue-500/90"
        onClick={handleRestore}
        disabled={isLoading}
      >
        <RotateCcw className={`size-5 ${isLoading ? 'animate-spin' : ''}`} />
        <span className="sr-only">{t('ORGTRASH_ACTION_RESTORE')}</span>
      </Button>
    </div>
  );
};

export default TrashRowActions;
